import './PatientListTableComponent.scss'
import React from 'react';
import {ITableColumn} from '../../../shared/models/table.model';
import {IPatient} from '../../../shared/models/patient.model';
import {CommonService} from "../../../shared/services";
import {Link} from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {APIConfig} from "../../../constants";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";
import TooltipComponent from "../../../shared/components/tooltip/tooltipComponent";

interface PatientListTableComponentProps {
    filterData?: {};
}

const PatientListTableComponent = (props: PatientListTableComponentProps) => {

    const {filterData} = props;

    const columns: ITableColumn[] = [

        {
            id: 'firstName', label: 'First Name', isDefaultColumn: true, fixed: "left",
            content: (item: IPatient) => (
                <>
                    {CommonService.capitalizeFirstLetterOfEachWord(item.firstName)}
                </>
            )
        },

        {
            id: 'lastName', label: 'Last Name', isDefaultColumn: true, fixed: "left",
            content: (item: IPatient) => (
                <>
                    {CommonService.capitalizeFirstLetterOfEachWord(item.lastName)}
                </>
            )
        },
        {
            id: 'dateOfBirth', label: 'Date of Birth',
            isDefaultColumn: true, align: 'center',
            content: (item: IPatient) => (
                <>
                    {commonService.formatDate(item?.dateOfBirth)}
                </>
            )
        },
        {
            id: 'gender', label: 'Gender', isDefaultColumn: false, align: 'center', width: "100",
            content: (item: IPatient) => (
                <>
                    {CommonService.capitalizeFirstLetterOfEachWord(item.gender)}
                </>
            )
        },

        {
            id: 'mobileNumber', label: 'Phone', isDefaultColumn: true, align: 'center',
            content: (item: IPatient) => (
                item.mobileNumber ?
                    <>
                        {CommonService.getMaskedMobileNumber(item.mobileNumber)}
                    </> : <>-</>
            )
        },
        {
            id: 'address', label: 'Address',
            isDefaultColumn: false,
            content: (item: IPatient) => (
                <>
                    {
                        item ? <>
                            {item?.addressLine1 && <> {CommonService.capitalizeFirstLetterOfEachWord(item?.addressLine1)} &nbsp; </>}
                        </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'city', label: 'City', align: 'center', width: "150",
            isDefaultColumn: false,
            content: (item: IPatient) => (
                <>
                    {item?.city ? <>{CommonService.capitalizeFirstLetterOfEachWord(item?.city)}</> : <>NA</>}
                </>
            )
        },
        {
            id: 'state', label: 'State', align: 'center', width: "150",
            isDefaultColumn: false,
            content: (item: IPatient) => (
                <>
                    {item?.state ? <>{CommonService.capitalizeFirstLetterOfEachWord(item?.state)}</> : <>NA</>}
                </>
            )
        },
        {
            id: 'addedBy', label: 'Added by', isDefaultColumn: true, align: 'center',
            content: (item: IPatient) => (
                <React.Fragment>
                    {
                        item.createdByDetails ? <>
                            {CommonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.firstName)} {CommonService.capitalizeFirstLetterOfEachWord(item?.createdByDetails?.lastName)}
                        </> : <> - </>
                    }
                </React.Fragment>
            )
        },

        {
            id: 'externalId', label: 'External ID', isDefaultColumn: false, align: 'center',
            content: (item: IPatient) => (
                <React.Fragment>
                    {
                        item.externalPatientId ? <> item.externalPatientId
                        </> : <> - </>
                    }
                </React.Fragment>
            )
        },
        {
            id: 'assignedLocations', label: 'Linked Locations', isDefaultColumn: true, align: 'center',
            content: (item: IPatient) => {
                let locationNames = item?.locations?.map((location:any)=> location?.name)
                if (locationNames && locationNames?.length > 0){
                    locationNames = locationNames?.join(',')
                }
                else {
                    locationNames = 'NA'
                }

               return( <React.Fragment>

                       {locationNames?.length > 30 ?
                        <TooltipComponent
                            tooltip={commonService.capitalizeFirstLetterOfEachWord(locationNames)}
                            placement="top"
                            arrow={true}>
                        <div className={"ellipses-for-table-data"}>
                            {commonService.capitalizeFirstLetterOfEachWord(locationNames)}
                        </div>
                        </TooltipComponent>:
                            <>{commonService.capitalizeFirstLetterOfEachWord(locationNames)}</>
                       }
                </React.Fragment>)
            }
        },
        {
            id: 'assignedFacilities', label: 'Linked Facilities', isDefaultColumn: true, align: 'center',
            content: (item: IPatient) => {
                let facilityNames = item?.locations?.map((location:any)=> location?.facilityDetails?.name)
                if (facilityNames && facilityNames?.length > 0){
                    facilityNames = facilityNames?.join(',')
                }
                else {
                    facilityNames = 'NA'
                }

                return( <React.Fragment>

                    {facilityNames?.length > 30 ?
                        <TooltipComponent
                            tooltip={commonService.capitalizeFirstLetterOfEachWord( facilityNames)}
                            placement="top"
                            arrow={true}>
                            <div className={"ellipses-for-table-data"}>
                                {commonService.capitalizeFirstLetterOfEachWord(facilityNames)}
                            </div>
                        </TooltipComponent>:
                        <>{commonService.capitalizeFirstLetterOfEachWord(facilityNames)}</>
                    }
                </React.Fragment>)
            }
        },
        // {
        //     id: 'addedDate', label: 'Added On', isDefaultColumn: true, align: 'center',
        //     content: (item: IPatient) => (
        //         <React.Fragment>
        //             {
        //                 item ?
        //                     <>
        //                         {moment(item?.createdAt).format('YYYY-MM-DD')}
        //                         &nbsp;|&nbsp;
        //                         {moment(item?.createdAt).format('HH:mm')}
        //                     </> : <> - </>
        //             }
        //
        //         </React.Fragment>
        //     )
        // },

        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            align: 'center',
            width: "100",
            fixed: "right",
            content: (item: IPatient, index: any) => (
                <React.Fragment>
                    <div className="table-actions" id={`view_patient_` + index}>
                        <Link to={CommonService._routeConfig.PatientDetailsRoute(item?.id)}>
                            <div className="table-action">
                                <ChevronRightIcon/>
                            </div>
                        </Link>
                    </div>
                </React.Fragment>
            )
        },
    ];

    return (
        <div className="table-list-container">
            <TableWrapperV2Component
                isPaginated={true}
                columns={columns}
                url={APIConfig.PATIENT_LIST.URL}
                method={APIConfig.PATIENT_LIST.METHOD}
                extraPayload={filterData}
                isColumnFilterVisible={true}
            />
        </div>
    )
};

export default PatientListTableComponent;
